/*
 * Copyright (C) 2023 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import $ from 'jquery'
import teacherDialog from '../../../views/jst/registration/teacherDialog.handlebars'
import deparam from 'deparam'
import I18n from '@canvas/i18n'

export default function (signupDialog) {
  signupDialog.afterRender = function () {
    const $org = $('#teacher_organization_type')
    const $title = $('#teacher_school_position')
    const optsHtml = $title.html()
    $title.prop('disabled', true)
    return $org.on('change', function () {
      $title.html(optsHtml)
      switch ($org.val()) {
        case 'Higher Ed':
        case 'Higher Ed For-Profit':
          return $title.prop('disabled', false).find('.k-12, .corporate, .government').remove()
        case 'K12':
        case 'K12 For-Profit':
          return $title.prop('disabled', false).find('.higher-ed, .corporate, .government').remove()
        case 'Corporate':
          return $title.prop('disabled', false).find('.k-12, .higher-ed, .government').remove()
        case 'Government':
          return $title.prop('disabled', false).find('.k-12, .higher-ed, .corporate').remove()
        default:
          return $title.prop('disabled', true)
      }
    })
  }
  signupDialog.teardown = function () {
    return $('#teacher_organization_type').off('change')
  }
  let ref, ref1, ref2
  // eslint-disable-next-line no-void
  const settings = (ref = ENV.ACCOUNT) != null ? ref.registration_settings : void 0
  // eslint-disable-next-line no-void
  if (settings != null ? settings.salesforce : void 0) {
    signupDialog.templates.teacherDialog = teacherDialog
    const params = deparam()
    settings.tracking_fields = [
      {
        name: 'user[lead_source]',
        value: (ref1 = params.lead_source) != null ? ref1 : 'Free_For_Teacher_Request',
      },
      {
        name: 'user[lead_source_description]',
        value:
          (ref2 = params.lead_source_description) != null
            ? ref2
            : I18n.strftime(new Date(), '%Y-%m-%d'),
      },
    ]
  }
  return signupDialog
}
